import { useContext } from 'react';
import { NewCommunicationValuesContext } from './NewCommunicationContext';

export const useNewCommunicationValues = () => {
  const context = useContext(NewCommunicationValuesContext);

  if (!context) {
    throw new Error('useNewCommunicationValues must be used within a NewCommunicationProvider');
  }

  return context;
};
